import { VSlider } from 'vuetify/lib'
import commonMixins from './commonMixins'
import { defaultFun } from '../utils'
import { SLIDER } from '../type_name'
export default {
    name: SLIDER,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,
             key,
             start = defaultFun,
             end = defaultFun,
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        return h(VSlider, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value: this.my_value[key]
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    change(data)
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
                start,
                end
            }
        })
    }
}